import { cn } from 'src/utils/utils';

import { type SidebarState, useSidebarState } from './hooks';
import SidebarV2 from './SidebarV2';

const EXPANDED_WIDTH = 'tw:w-[240px]';
const COLLAPSED_WIDTH = 'tw:w-[60px]';

export interface DrawerV2Props {
  state?: SidebarState;
}

const DrawerV2 = ({ state: sharedState }: DrawerV2Props) => {
  const fallback = useSidebarState();
  const state = sharedState ?? fallback;
  const { isOpen, isMobile, close } = state;

  if (isMobile) {
    return (
      <>
        {isOpen ? (
          <div
            className="tw:fixed tw:inset-0 tw:z-1200 tw:bg-black/40"
            onClick={close}
            aria-hidden
          />
        ) : null}
        <aside
          className={cn(
            'tw:fixed tw:inset-y-0 tw:left-0 tw:z-1250 tw:w-[280px] tw:max-w-[85vw]',
            'tw:border-r tw:border-border-secondary tw:bg-main',
            'tw:transition-transform tw:duration-200 tw:ease-in-out',
            isOpen ? 'tw:translate-x-0' : 'tw:-translate-x-full'
          )}
        >
          <SidebarV2 state={state} />
        </aside>
      </>
    );
  }

  return (
    <aside
      className={cn(
        'tw:relative tw:h-full tw:shrink-0 tw:bg-main',
        'tw:will-change-[width] tw:transition-[width] tw:duration-300 tw:ease-in-out',
        // Visible when collapsed so the history hover-flyout can escape the rail.
        isOpen ? 'tw:overflow-hidden' : 'tw:overflow-visible',
        isOpen ? EXPANDED_WIDTH : COLLAPSED_WIDTH
      )}
    >
      <SidebarV2 state={state} />
    </aside>
  );
};

export default DrawerV2;
